import { formatCnpj } from "utils/federal-tax-id";

/**
 * Formata o CNPJ para leitura. Não valida: o dado vem do cadastro, e o que
 * chegar diferente de 14 dígitos é devolvido como veio, em vez de virar uma
 * máscara truncada que parece outro documento. Delega para o formatador
 * único (`utils/federal-tax-id`).
 */
export function formatFederalTaxId(value?: string): string {
  return formatCnpj(value);
}
